import { usePermissions } from "@/shared/hooks/usePermissions";
import type { UserPermissionsData } from "@/shared/components/users/UserPermissions";
import { Loader2, ShieldAlert } from "lucide-react";

interface PermissionGuardProps {
  module: keyof UserPermissionsData;
  operation?: "visualizar" | "incluir" | "alterar" | "excluir";
  children: React.ReactNode;
  /** If true, renders nothing instead of the blocked message */
  silent?: boolean;
}

const PermissionGuard = ({ module, operation = "visualizar", children, silent = false }: PermissionGuardProps) => {
  const { hasPermission, loading } = usePermissions();

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!hasPermission(module, operation)) {
    if (silent) return null;
    return (
      <div className="flex flex-col items-center justify-center py-20 text-center space-y-4">
        <ShieldAlert className="h-12 w-12 text-muted-foreground" />
        <div>
          <h2 className="font-display text-lg font-semibold text-foreground">Acesso Restrito</h2>
          <p className="text-sm text-muted-foreground mt-1">
            Você não tem permissão para acessar esta funcionalidade.
          </p>
          <p className="text-xs text-muted-foreground mt-1">
            Fale com um administrador para solicitar acesso.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default PermissionGuard;
